import { Box, Typography, styled } from '@mui/material'

const ModalBody = styled(Box)`
  padding: 8px 32px;
  width: 100%;
  height: 100%;
  flex: 1;
`

export { ModalBody }
